module.exports = __webpack_public_path__ + "img/symbol_3.3d0d30ed.png";